export const M2_UNIT_13 = {
  id: "m2-u13",
  title: "Unit 13: Questions with Have",
  topic: "Possession Questions",
  iconType: "box", // Icono consistente con posesión
  grammarImage: "/m2-u13-grammar.jpg", // Recuerda subir esta imagen a public
  grammarText: "Para preguntar con 'Have', usamos el auxiliar 'Do' o 'Does' al principio. Ej: Do you have...? Does she have...?",
  sets: [
    {
      id: "u29-set1",
      title: "Set 1: Have Questions - Basic Do/Does",
      questions: [
        { type: "mc", q: "___ you have a TV?", options: ["Do", "Does"], a: "Do" },
        { type: "mc", q: "___ she have a TV?", options: ["Does", "Do"], a: "Does" },
        { type: "blank", q: "___ they have a toaster? (Do)", options: ["Do"], a: "Do" },
        { type: "mc", q: "___ Ben have a washing machine?", options: ["Does", "Do"], a: "Does" },
        { type: "blank", q: "___ you have a new couch? (Do)", options: ["Do"], a: "Do" },
        { type: "order", q: "Ordena: Does she have an oven?", words: ["Does", "she", "have", "an", "oven?"], a: "Does she have an oven?" },
        { type: "mc", q: "'Do we have?' correct = True.", options: ["True", "False"], a: "True" },
        { type: "mc", q: "___ Karen have a large TV?", options: ["Does", "Do"], a: "Does" },
        { type: "blank", q: "___ the kitchen have a sink? (Does)", options: ["Does"], a: "Does" },
        { type: "order", q: "Ordena: Do you have an old armchair?", words: ["Do", "you", "have", "an", "old", "armchair?"], a: "Do you have an old armchair?" }
      ]
    },
    {
      id: "u29-set2",
      title: "Set 2: Question Word Order",
      questions: [
        { type: "order", q: "Ordena: you a new couch have Do?", words: ["Do", "you", "have", "a", "new", "couch?"], a: "Do you have a new couch?" },
        { type: "order", q: "Ordena: she an oven have Does?", words: ["Does", "she", "have", "an", "oven?"], a: "Does she have an oven?" },
        { type: "blank", q: "___ Ben have a washing machine? (Does)", options: ["Does"], a: "Does" },
        { type: "mc", q: "Do they have toaster? → ___", options: ["Do they have a toaster?", "Does they have toaster?"], a: "Do they have a toaster?" },
        { type: "blank", q: "___ you have a new couch? (Do)", options: ["Do"], a: "Do" },
        { type: "order", q: "Ordena: the house a yard have Does?", words: ["Does", "the", "house", "have", "a", "yard?"], a: "Does the house have a yard?" },
        { type: "mc", q: "'Does Karen TVs?' Wrong article.", options: ["True"], a: "True" },
        { type: "order", q: "Ordena: Noah a dog have Does?", words: ["Does", "Noah", "have", "a", "dog?"], a: "Does Noah have a dog?" },
        { type: "blank", q: "___ the house have a yard? (Does)", options: ["Does"], a: "Does" },
        { type: "order", q: "Ordena: you a spoon have Do?", words: ["Do", "you", "have", "a", "spoon?"], a: "Do you have a spoon?" }
      ]
    },
    {
      id: "u29-set3",
      title: "Set 3: Kitchen Objects Vocabulary",
      questions: [
        { type: "mc", q: "Heat bread: ", options: ["toaster", "microwave", "kettle"], a: "toaster" },
        { type: "mc", q: "Heat water: ", options: ["kettle", "dishwasher", "plate"], a: "kettle" },
        { type: "blank", q: "Wash dishes: ___ (dishwasher).", options: ["dishwasher"], a: "dishwasher" },
        { type: "mc", q: "Heat food fast: ", options: ["microwave", "fork", "bowl"], a: "microwave" },
        { type: "blank", q: "Wash clothes: ___ machine (washing).", options: ["washing"], a: "washing" },
        { type: "order", q: "Ordena: cutlery", words: ["cutlery"], a: "cutlery" },
        { type: "mc", q: "Eat with: knife, fork, spoon = ", options: ["silverware", "plates"], a: "silverware" },
        { type: "mc", "q": "Soup: ", options: ["bowl", "cup", "knife"], a: "bowl" },
        { type: "blank", q: "Drink: ___ (cup).", options: ["cup"], a: "cup" },
        { type: "order", q: "Ordena: knife fork spoon", words: ["knife,", "fork,", "spoon"], a: "knife, fork, spoon" }
      ]
    },
    {
      id: "u29-set4",
      title: "Set 4: Short Answers",
      questions: [
        { type: "mc", q: "Do you have a kettle? ", options: ["Yes, I do.", "Yes, I am."], a: "Yes, I do." },
        { type: "mc", q: "Does Noah have a dog? ", options: ["Yes, he does.", "Yes, he is."], a: "Yes, he does." },
        { type: "blank", q: "Do you have a fork? No, ___ don't.", options: ["I"], a: "I" },
        { type: "mc", "q": "Does he have a TV? ", options: ["No, he doesn't.", "No, he's not."], a: "No, he doesn't." },
        { type: "blank", "q": "Do you have a spoon? Yes, ___ do.", options: ["I"], a: "I" },
        { type: "order", "q": "Ordena: Does he have a bookcase? No, he doesn't.", words: ["No,", "he", "doesn't."], a: "No, he doesn't." },
        { type: "mc", "q": "'Yes, there is.' Wrong answer. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "Does he have a couch? ", options: ["Yes, he does.", "No, he isn't."], a: "Yes, he does." },
        { type: "blank", "q": "Do you have a toaster? No, ___ don't.", options: ["I"], a: "I" },
        { type: "order", "q": "Ordena: Do you have a microwave? Yes, I do.", words: ["Yes,", "I", "do."], a: "Yes, I do." }
      ]
    },
    {
      id: "u29-set5",
      title: "Set 5: Any Questions",
      questions: [
        { type: "mc", "q": "Do you have ___ chairs?", options: ["any", "a"], a: "any" },
        { type: "mc", "q": "Does he have ___ plates?", options: ["any", "some"], a: "any" },
        { type: "blank", "q": "Do you have ___ kettle? (any)", options: ["any"], a: "any" },
        { type: "mc", "q": "Does it have ___ plates?", options: ["any", "a"], a: "any" },
        { type: "blank", "q": "Do they have ___ chairs? (any)", options: ["any"], a: "any" },
        { type: "order", "q": "Ordena: Do you have any chairs?", words: ["Do", "you", "have", "any", "chairs?"], a: "Do you have any chairs?" },
        { type: "mc", "q": "'Do you have a chairs?' Wrong. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "Does she have ___ toaster?", options: ["a", "any"], a: "a" },
        { type: "blank", "q": "Do you have ___ plates? (any)", options: ["any"], a: "any" },
        { type: "order", "q": "Ordena: Does he have any plates?", words: ["Does", "he", "have", "any", "plates?"], a: "Does he have any plates?" }
      ]
    },
    {
      id: "u29-set6",
      title: "Set 6: Have Got Questions",
      questions: [
        { type: "mc", "q": "___ you got a cat?", options: ["Have", "Has"], a: "Have" },
        { type: "mc", "q": "___ this town got a theater?", options: ["Has", "Have"], a: "Has" },
        { type: "blank", "q": "___ Milo got a washing machine? (Has)", options: ["Has"], a: "Has" },
        { type: "mc", "q": "___ your house got an attic? (Has)", options: ["Has", "Have"], a: "Has" },
        { type: "blank", "q": "___ they got laptops? (Have)", options: ["Have"], a: "Have" },
        { type: "order", "q": "Ordena: Have you got a cat?", words: ["Have", "you", "got", "a", "cat?"], a: "Have you got a cat?" },
        { type: "mc", "q": "'Has you got?' Wrong = True.", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "___ she got a toaster?", options: ["Has", "Have"], a: "Has" },
        { type: "blank", "q": "___ the house got a dining room? (Has)", options: ["Has"], a: "Has" },
        { type: "order", "q": "Ordena: Does this coffee shop have a bathroom?", words: ["Does", "this", "coffee", "shop", "have", "a", "bathroom?"], a: "Does this coffee shop have a bathroom?" }
      ]
    },
    {
      id: "u29-set7",
      title: "Set 7: Mixed Questions (Medium)",
      questions: [
        { type: "mc", "q": "Do you have a cat? / Have you got a cat?", options: ["Same meaning", "Different"], a: "Same meaning" },
        // Convertido a MC para soportar 2 respuestas
        { type: "mc", "q": "___ you have any chairs? / ___ you got any chairs? (Do/Have)", options: ["Do / Have", "Have / Do"], a: "Do / Have" },
        { type: "mc", "q": "Does she have a toaster? Correct.", options: ["True", "False"], a: "True" },
        { type: "order", "q": "Mix: Do/Does + Have got", words: ["Does", "he", "have", "a", "TV?", "Has", "he", "got", "a", "TV?"], a: "Does he have a TV? Has he got a TV?" },
        // Convertido a MC
        { type: "mc", "q": "___ Noah have a dog? / ___ Noah got a dog? (Does/Has)", options: ["Does / Has", "Do / Have"], a: "Does / Has" },
        { type: "mc", "q": "'Do she have?' Wrong subject.", options: ["True"], a: "True" },
        { type: "mc", "q": "The house has a sink. Question?", options: ["Does the house have a sink?", "Do the house have?"], a: "Does the house have a sink?" },
        // Convertido a MC
        { type: "mc", "q": "___ you have a microwave? / ___ you got? (Do/Have)", options: ["Do / Have", "Did / Has"], a: "Do / Have" },
        { type: "order", "q": "Does Karen have TV? Has she got?", words: ["Does", "Karen", "have", "a", "TV?", "Has", "she", "got", "a", "TV?"], a: "Does Karen have a TV? Has she got a TV?" },
        { type: "mc", "q": "All correct: Do you? Does he? Have you got?", options: ["True"], a: "True" }
      ]
    },
    {
      id: "u29-set8",
      title: "Set 8: Picture Questions",
      questions: [
        { type: "mc", "q": "Do you have a kettle? (picture: yes)", options: ["Yes, I do.", "No, I don't."], a: "Yes, I do." },
        { type: "blank", "q": "Does Noah have a dog? (yes) Yes, ___ does.", options: ["he"], a: "he" },
        { type: "mc", "q": "Do you have a fork? (no)", options: ["No, I don't.", "Yes, I do."], a: "No, I don't." },
        { type: "blank", "q": "Does he have a TV? (no) No, ___ doesn't.", options: ["he"], a: "he" },
        { type: "mc", "q": "Do you have a spoon? (yes)", options: ["Yes, I do.", "No, I don't."], a: "Yes, I do." },
        { type: "order", "q": "Does he have a bookcase? (no)", words: ["No,", "he", "doesn't."], a: "No, he doesn't." },
        { type: "mc", "q": "Do you have a toaster? (no)", options: ["No, I don't.", "Yes, I do."], a: "No, I don't." },
        { type: "blank", "q": "Does he have a couch? (yes) Yes, ___ does.", options: ["he"], a: "he" },
        { type: "mc", "q": "Do you have a microwave? (yes)", options: ["Yes, I do."], a: "Yes, I do." },
        { type: "order", "q": "Does Noah have a TV? (no)", words: ["No,", "he", "doesn't."], a: "No, he doesn't." }
      ]
    },
    {
      id: "u29-set9",
      title: "Set 9: Error Correction",
      questions: [
        { type: "mc", "q": "Does she has an oven? (Fix)", options: ["Does she have an oven?", "Does she has oven?"], a: "Does she have an oven?" },
        { type: "blank", "q": "Do they has toaster? → Do they ___ toaster?", options: ["have"], a: "have" },
        { type: "mc", "q": "Do Ben have washing machine? Wrong?", options: ["True, Does Ben", "False"], a: "True, Does Ben" },
        // Corregido: orden lógico
        { type: "order", "q": "Corrige: You does have couch?", words: ["Do", "you", "have", "a", "couch?"], a: "Do you have a couch?" },
        { type: "blank", "q": "Does we have armchair? → ___ we have?", options: ["Do"], a: "Do" },
        { type: "mc", "q": "'Does Karen large TV?' Wrong article.", options: ["True"], a: "True" },
        { type: "mc", "q": "The kitchen have sink? Fix?", options: ["Does the kitchen have a sink?", "Do kitchen have sink?"], a: "Does the kitchen have a sink?" },
        { type: "blank", "q": "Do the house have yard? → Does the house ___ yard?", options: ["have a"], a: "have a" },
        // Corregido: orden lógico
        { type: "order", "q": "Corrige: Has you got cat?", words: ["Have", "you", "got", "a", "cat?"], a: "Have you got a cat?" },
        { type: "mc", "q": "Do Noah dog? Wrong structure.", options: ["True"], a: "True" }
      ]
    },
    {
      id: "u29-set10",
      title: "Set 10: Full Challenge Mix",
      questions: [
        { type: "mc", "q": "Complete: Do you have cat? / Does she have oven? / Have you got kettle?", options: ["All need 'a/an'", "All correct"], a: "All need 'a/an'" },
        // Convertido a MC para soportar 4 respuestas
        { type: "mc", "q": "Do/Does + any: ___ you have ___ chairs? / ___ he have ___ plates?", options: ["Do/any/Does/any", "Does/some/Do/a"], a: "Do/any/Does/any" },
        { type: "order", "q": "Master: kitchen questions", words: ["Does", "the", "kitchen", "have", "a", "sink?", "Do", "you", "have", "any", "plates?"], a: "Does the kitchen have a sink? Do you have any plates?" },
        { type: "mc", "q": "Quick: Does Noah dog? Fix?", options: ["Does Noah have a dog?", "Do Noah have dog?"], a: "Does Noah have a dog?" },
        // Convertido a MC
        { type: "mc", "q": "Short answers: Yes, ___ do. / No, ___ doesn't. (I/he)", options: ["I / he", "he / I"], a: "I / he" },
        { type: "mc", "q": "Have got British / Do/Does American. True?", options: ["True", "False"], a: "True" },
        { type: "order", "q": "Challenge: full dialogue", words: ["Do", "you", "have", "a", "kettle?", "Yes,", "I", "do.", "Does", "Noah", "have", "a", "dog?", "Yes,", "he", "does."], a: "Do you have a kettle? Yes, I do. Does Noah have a dog? Yes, he does." },
        // Convertido a MC
        { type: "mc", "q": "Any questions: Do you have ___ toaster? / Does she have ___ microwave? (any/any)", options: ["any / any", "some / a"], a: "any / any" },
        { type: "mc", "q": "All correct forms? Do you/Does he/Have you got.", options: ["True"], a: "True" },
        // Corregido frase final
        { type: "order", "q": "Ultimate: kitchen inventory questions.", words: ["Do", "you", "have", "any", "plates", "and", "a", "toaster?", "Does", "the", "kitchen", "have", "a", "sink?"], a: "Do you have any plates and a toaster? Does the kitchen have a sink?" }
      ]
    }
  ]
};
